import { render, staticRenderFns } from "./MdArrowRightIcon.vue?vue&type=template&id=bae0162e"
import script from "./MdArrowRightIcon.vue?vue&type=script&lang=js"
export * from "./MdArrowRightIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports